import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";

const Article = () => {
  return (
    <div className="bg-[#F3F2EF] !py-2 lg:py-0">
      <div className="container mx-auto mt-12">
        <div className="flex flex-col-reverse md:flex-row justify-between items-center gap-4 px-4 sm:px-6 lg:px-8">
          <div className="md:w-1/2 text-center md:text-left">
            <h1 className="text-4xl lg:text-[55px] font-normal leading-10 lg:leading-[67px] pl-0 md:pl-4 w-full ">
              Welcome to your professional community
            </h1>
            <div className="flex flex-col w-full  py-6">
              <button className="w-full md:w-auto bg-gray-200 text-lg py-2 px-4 font-medium rounded-full mb-4">
                Continue with Google
              </button>
              <Link to={"user/login"}  className="w-full md:w-auto bg-gray-200 text-center text-lg py-2 px-4 font-medium rounded-full mb-4">
              <button>
                Sign in with email
              </button>
              </Link>
            </div>
            <p className="text-sm text-gray-600 mb-4 w-full ">
              By clicking Continue to join or sign in, you agree to LinkedIn’s
              <Link className="text-black font-bold" to="#">
                {" "}
                User Agreement
              </Link>
              ,
              <Link className="text-black font-bold" to="#">
                {" "}
                Privacy Policy
              </Link>
              , and
              <Link className="text-black font-bold" to="#">
                {" "}
                Cookie Policy
              </Link>
              .
            </p>
            <p className="text-sm text-gray-600">
              New to LinkedIn?
              <button className="text-black font-bold"> Join Now</button>
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center md:justify-end mt-8 md:mt-0">
            <img
              src="/Images/image 1.png"
              alt="Section-1"
              className="w-3/4 md:w-full"
            />
          </div>
        </div>
        <div className="mt-10 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 md:flex-row items-center">
            <div className="w-full text-center md:text-left">
              <h2 className="text-3xl md:text-5xl mb-4 !leading-10 md:!leading-[61px] w-full md:w-96 2xl:w-3/4">
                Explore collaborative articles
              </h2>
              <p className="text-xl text-gray-600 mb-8 w-full md:w-96 2xl:w-3/4">
                We’re unlocking community knowledge in a new way. Experts add
                insights directly into each article, started with the help of
                AI.
              </p>
            </div>
            <div className="md:w-full flex flex-wrap gap-4 justify-center md:justify-start">
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Marketing
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Healthcare
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Engineering
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Public Administration
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                IT Services
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Sustainability
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Telecommunications
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Business Administration
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                HR Management
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Show all
              </button>
            </div>
          </div>
        </div>
        <div className="mt-10 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 md:flex-row items-center">
            <div className="w-full text-center md:text-left">
              <h2 className="text-3xl lg:text-5xl mb-4 !leading-10 lg:!leading-[61px] w-full md:w-96 2xl:w-3/4">
                Find the right job or internship for you
              </h2>
            </div>
            <div className="md:w-full flex flex-wrap gap-4 justify-center md:justify-start">
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Engineering
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Finance
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Business Development
              </button>

              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Operations
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Administrative Assistant
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Retail Associate
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Customer Service
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Information Technology
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Human Resource
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Show all
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#FFE7B9]">
        <div className="flex items-center justify-center mt-16 py-24 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-2xl md:text-4xl text-blue-600 mb-4">
              Post your job for millions of people to see
            </h1>
            <button className="border border-blue-600 text-blue-600 py-2 px-4 rounded hover:bg-blue-600 hover:text-white transition duration-300">
              Post a job
            </button>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row gap-4 items-center mt-16 px-4 sm:px-6 lg:px-8">
          <div className="md:w-full text-center md:text-left">
            <h2 className="text-3xl lg:text-5xl !leading-10 lg:!leading-[61px] mb-4 w-full md:w-96">
              Discover the best software tools
            </h2>
            <p className="text-xl text-gray-600 mb-8 w-full md:w-96 2xl:w-3/4">
              Connect with buyers who have first-hand experience to find the
              best products for you.
            </p>
          </div>
          <div className="md:w-full flex flex-wrap gap-4 justify-center md:justify-start">
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              E-Commerce Platforms
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              CRM Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Human Resources Management Systems
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Recruiting Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Sales Intelligence Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Project Management Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Help Desk Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Social Networking Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Desktop Publishing Software
            </div>
            <div className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
              Show all
            </div>
          </div>
        </div>
        <div className="mt-10 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 md:flex-row items-center">
            <div className="w-full text-center md:text-left">
              <h2 className="text-3xl lg:text-5xl mb-4 !leading-10 lg:!leading-[61px] w-full md:w-96 2xl:w-3/4">
                Keep your mind sharp with games
              </h2>
            </div>
            <div className="md:w-full flex flex-wrap gap-4 justify-center md:justify-start">
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Pinpoint
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Queens
              </button>
              <button className="bg-gray-200 text-lg py-2 px-4 rounded-lg">
                Crossclimb
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#FFE7B9]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse md:flex-row items-center justify-center gap-4 mt-16 py-12 ">
            <div className="w-full text-center md:text-left mb-6 md:mb-0">
              <h1 className="text-4xl md:text-5xl text-black mb-4 w-full md:w-3/4">
                Conversations today could lead to opportunity tomorrow
              </h1>
              <p className="text-lg text-black mb-6 w-full md:w-3/4">
                Sending messages to people you know is a great way to strengthen
                relationships as you take the next step in your career.
              </p>
              <div className="flex justify-center md:justify-end space-x-6">
                <button className="bg-blue-600 w-12 h-12 text-white p-2 rounded-full">
                  <i className="fas fa-arrow-left"></i>
                </button>
                <button className="bg-blue-600 w-12 h-12 text-white p-2 rounded-full">
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
            <div className="w-full flex items-center justify-center">
              <img
                src="/Images/homepage/Rectangle 49.png"
                alt="A person smiling while working on a laptop"
                className="rounded-lg shadow-lg h-1/2 sm:h-auto md:h-3/4 lg:h-auto w-1/2 sm:-w-auto md:w-3/4 lg:w-auto"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4">
          <div className="w-full flex flex-col justify-center items-center py-12 lg:py-20 px-8 lg:px-24">
            <img
              src="/Images/homepage/image 4.png"
              alt="A person smiling while working on a laptop"
              className="shadow-lg w-full h-auto"
            />
            <p className="text-center md:text-start text-2xl lg:text-3xl xl:text-4xl !leading-8 lg:!leading-10 tracking-wide font-semibold mt-4 w-full">
              Connect with people who can help
            </p>
            <div className="bg-gray-200 w-auto py-2 px-4 rounded-lg mt-4">
              <p className="text-center text-xl">Find People you know</p>
            </div>
          </div>
          <div className="w-full flex flex-col justify-center items-center py-12 lg:py-20 px-8 lg:px-24">
            <img
              src="/Images/homepage/image 5.png"
              alt="A person smiling while working on a laptop"
              className="shadow-lg w-full h-auto"
            />
            <p className="text-center md:text-start text-2xl lg:text-3xl xl:text-4xl !leading-8 lg:!leading-10 tracking-wide font-semibold mt-4 w-full">
              Learn the skills you need to succeed
            </p>
            <div className="bg-gray-200 w-auto py-2 px-4 rounded-lg mt-4">
              <p className="text-center text-xl">
                Choose a topic to learn about
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8  px-4 sm:px-6 lg:px-8">
          <div className="bg-[#D9D9D9] py-24 w-full">
            <div className="flex flex-col items-center justify-center">
              <h2 className="text-blue-600 text-3xl sm:text-5xl font-bold mb-2">
                Who is LinkedIn for?
              </h2>
              <p className="text-gray-700 mb-4 text-sm sm:text-base">
                Anyone looking to navigate their professional life.
              </p>
              <div className="space-y-4 ml-0 xl:ml-24">
                <button className="w-full bg-yellow-200 text-left text-xl sm:text-3xl p-3 rounded-lg flex justify-between items-center">
                  Find a coworker or classmate{" "}
                  <i className="fas fa-chevron-right ml-4 xl:ml-24"></i>
                </button>
                <button className="w-full bg-yellow-200 text-left text-xl sm:text-3xl p-3 rounded-lg flex justify-between items-center">
                  Find a new job{" "}
                  <i className="fas fa-chevron-right ml-4 xl:ml-24"></i>
                </button>
                <button className="w-full bg-yellow-200 text-left text-xl sm:text-3xl p-3 rounded-lg flex justify-between items-center">
                  Find a course or training{" "}
                  <i className="fas fa-chevron-right ml-4 xl:ml-24"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="w-1/2 xl:w-2/5">
            <img
              src="/Images/homepage/image 6.png"
              alt="Two people looking at a laptop with a background of knowledge-related icons"
              className=""
            />
          </div>
        </div>
      </div>
      <div className="bg-[#FFE7B9]">
        <div className="container mx-auto">
          <div className="flex items-center justify-center gap-3 mt-16 py-12 px-4 sm:px-6 lg:px-8">
            <div className="w-full text-center md:text-left">
              <h1 className="text-lg sm:text-2xl md:text-3xl lg:text-5xl text-left text-semibold mb-4 w-full">
                Join your colleagues, classmates, and friends on LinkedIn.
              </h1>
            </div>
            <div className="w-1/3 sm:w-1/4 md:w-1/5 flex items-center justify-center">
              <button className="w-auto text-center text-sm sm:text-[22px] xl:text-3xl text-white py-3 px-4 bg-[#2C56A0] rounded-full">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Article;
